import styled, {css} from "styled-components";
import {getCssSizeValue} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import useIsDebug from "@/hooks/useIsDebug";

const topMarginStyle = css`
    padding-top: ${({$marginSizes}) => getCssSizeValue($marginSizes.TOP.MOBILE, BREAKPOINTS.MOBILE)};

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        padding-top: ${({$marginSizes}) => getCssSizeValue($marginSizes.TOP.TABLET, BREAKPOINTS.TABLET)};
    }

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        padding-top: ${({$marginSizes}) => getCssSizeValue($marginSizes.TOP.DESKTOP, BREAKPOINTS.DESKTOP)};
    }
`;

const bottomMarginStyle = css`
    padding-bottom: ${({$marginSizes}) => getCssSizeValue($marginSizes.BOTTOM.MOBILE, BREAKPOINTS.MOBILE)};

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        padding-bottom: ${({$marginSizes}) => getCssSizeValue($marginSizes.BOTTOM.TABLET, BREAKPOINTS.TABLET)};
    }

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        padding-bottom: ${({$marginSizes}) => getCssSizeValue($marginSizes.BOTTOM.DESKTOP, BREAKPOINTS.DESKTOP)};
    }
`;

const MarginWrapper = styled.div`
    ${({$debug}) => $debug && 'border: 1px solid blue;'}
    ${({$marginTop}) => $marginTop && topMarginStyle}
    ${({$marginBottom}) => $marginBottom && bottomMarginStyle}
`;

const DynamicMargin = ({
	children,
	marginTop = false,
	marginBottom = false,
	marginSizes = null,
	className = '',
	...props
}) => {
	const debug = useIsDebug()

	return <MarginWrapper
		$marginTop={marginTop}
		$marginBottom={marginBottom}
		$marginSizes={marginSizes}
		$debug={debug}
		className={className}
		{...props}
	>
		{children}
	</MarginWrapper>
}

export default DynamicMargin;